import React from 'react';
import { Dialog, Divider } from '@mui/material';
import { IconX } from '@tabler/icons-react';
import PaymentDetailsContent from './PaymentDetailsContent';
import { RoomDetail } from '../types';
import { TripBenefit } from '../../../gql/graphql';

interface PaymentDetailsModalProps {
  open: boolean;
  onClose: () => void;
  tripBenefits: TripBenefit[] | undefined;
  roomDetails: RoomDetail[];
}

const PaymentDetailsModal: React.FC<PaymentDetailsModalProps> = ({
  open,
  onClose,
  tripBenefits,
  roomDetails,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="payment-details-title"
      aria-describedby="payment-details-description"
      fullWidth
      maxWidth="sm"
      slotProps={{
        paper: {
          sx: theme => ({
            [theme.breakpoints.only('xs')]: {
              margin: 0,
              width: '100%',
              maxWidth: '100%',
              maxHeight: '80vh',
              height: '80vh',
              borderRadius: '24px 24px 0 0',
              alignSelf: 'flex-end',
              overflowY: 'auto',
            },
            [theme.breakpoints.up('sm')]: {
              borderRadius: '24px',
            },
          }),
        },
      }}
    >
      <div className="w-full p-4">
        <div className="flex justify-center w-full relative">
          <IconX
            className="absolute left-0 cursor-pointer"
            size={24}
            onClick={onClose}
          />
          <span
            id="payment-details-title"
            className="text-neutral-800 font-semibold"
          >
            Price details
          </span>
        </div>
        <Divider
          sx={{ width: '100%', marginTop: '8px', marginBottom: '8px' }}
        />
        <div id="payment-details-description">
          <PaymentDetailsContent
            tripBenefits={tripBenefits}
            roomDetails={roomDetails}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default PaymentDetailsModal;
